import { useEffect, useRef, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import * as actions from "../../../_redux/students/StudentsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { useStudentsUIContext } from "../StudentsUIContext";
import { StudentRegistrationCancellationForm } from "./StudentRegistrationCancellationForm";

export function StudentRegistrationCancellation({
  ids,
  term,
  showRegistrationCancellation,
  closeRegistrationCancellation
}) {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      queryParams: studentsUIContext.queryParams,
    };
  }, [studentsUIContext]);

  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type } = useSelector(
    (state) => ({
      actionsLoading: state.studentPreInterviews.actionsLoading,
      isSuccess: state.studentPreInterviews.isSuccess,
      type: state.studentPreInterviews.type
    }),
    shallowEqual
  );
    
  useEffect(() => {
    return () => dispatch(actions.cleanStudentsState());
  }, [dispatch]);

  useEffect(() => {
    let _title = ids && ids.length > 1 ? "Kayıtları İptal Et" : "Kaydı İptal Et";
    setTitle(_title);
  }, [ids]);

  /** Belli Bir Öğrenci Listesinin Belli Bir Dönemdeki Kayıtlarını İptal Eder */
  const cancelRegistrations = (values) => {
    const data = { explanation: values.explanation }
    dispatch(actions.cancelRegistrations(term, ids, data)).then((result) => onResult(result));
  };
    
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => {
      closeRegistrationCancellation();
      dispatch(actions.getStudents(studentsUIProps.queryParams));
    }, 2500);
  };

  const btnRef = useRef();  
  const cancelRegistrationsClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Modal
      show={showRegistrationCancellation}
      onHide={closeRegistrationCancellation}
      aria-labelledby="registration-cancellation-title"
    >
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="registration-cancellation-title">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mt-5">
          <StudentRegistrationCancellationForm
            btnRef={btnRef}
            cancelRegistrations={cancelRegistrations}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <button
          type="submit"
          className="btn btn-danger"
          onClick={cancelRegistrationsClick}
        >
          İptal Et
        </button>
        <button
          type="button"
          className="btn btn-light"
          onClick={closeRegistrationCancellation}
        >
          Vazgeç
        </button>
      </Modal.Footer>
    </Modal>
  );
}